import { Link } from 'react-router-dom';
import type { Product } from '@hygh-vybe/lib';
import { productUrl } from '../utils/slug';
import './ProductCard.css';

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const hasEnoughRatings = product.totalRatings >= 3;

  return (
    <Link to={productUrl(product.productId, product.brandName, product.productName)} className="product-card" aria-label={`${product.productName} by ${product.brandName}`}>
      <div className="product-card__image-container">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.productName}
            className="product-card__image"
            loading="lazy"
          />
        ) : (
          <div className="product-card__image-placeholder" aria-hidden="true">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          </div>
        )}
        <span className="product-card__thc-badge">
          {product.thcContentMg}mg THC
        </span>
        {product.sponsored && (
          <span className="product-card__sponsored-label">Sponsored</span>
        )}
      </div>

      <div className="product-card__info">
        <h3 className="product-card__name">{product.productName}</h3>

        {product.description && (
          <p className="product-card__description">{product.description}</p>
        )}

        {hasEnoughRatings && (
          <div className="product-card__scores">
            <span className="product-card__rating" aria-label={`Rating: ${product.aggregateScore} out of 5`}>
              ★ {product.aggregateScore?.toFixed(1)}
            </span>
            {product.aggregateBuzzScore != null && (
              <span className="product-card__buzz" aria-label={`Buzz score: ${product.aggregateBuzzScore} out of 10`}>
                ⚡ {product.aggregateBuzzScore.toFixed(1)}
              </span>
            )}
            {product.aggregateUpDown && product.aggregateUpDown !== 'Neutral' && (
              <span className={`product-card__effect product-card__effect--${product.aggregateUpDown.toLowerCase()}`}>
                {product.aggregateUpDown === 'Up' ? '↑' : '↓'} {product.aggregateUpDown}
              </span>
            )}
          </div>
        )}

        {product.manufacturerState && (
          <p className="product-card__location">📍 {product.manufacturerState}</p>
        )}

        <p className="product-card__cta-hint">✍️ Review</p>
      </div>
    </Link>
  );
}
